import { FORTA_BLUE, FORTA_WHITE } from '../../../../../utils/colors';

import type { SxProps, Theme } from '@mui/material';

export const DOCUMENT_PREVIEW_BOUNDS_SX: SxProps<Theme> = {
  inset: 0,
  pointerEvents: 'none',
  position: 'fixed',
  // Sit below MUI Dialog so ConfirmDialog and other modals stack on top.
  zIndex: (theme) => theme.zIndex.modal - 1,
};

export const DOCUMENT_PREVIEW_PAPER_SX: SxProps<Theme> = {
  backgroundColor: FORTA_WHITE,
  border: `1px solid ${FORTA_BLUE.light1}`,
  borderRadius: '10px',
  boxShadow: '8px 8px 8px 0px rgba(74, 74, 74, 0.3)',
  overflow: 'hidden',
  pointerEvents: 'auto',
  position: 'absolute',
};

export const DOCUMENT_PREVIEW_RESIZABLE_SX: SxProps<Theme> = {
  '& .react-resizable': {
    position: 'relative',
  },
  '& .react-resizable-handle': {
    display: 'block',
    position: 'absolute',
    userSelect: 'none',
    zIndex: 2,
  },
  '& .react-resizable-handle-n': {
    cursor: 'ns-resize',
    height: 8,
    left: 12,
    top: 0,
    width: 'calc(100% - 24px)',
  },
  '& .react-resizable-handle-s': {
    bottom: 0,
    cursor: 'ns-resize',
    height: 8,
    left: 12,
    width: 'calc(100% - 24px)',
  },
  '& .react-resizable-handle-e': {
    cursor: 'ew-resize',
    height: 'calc(100% - 24px)',
    right: 0,
    top: 12,
    width: 8,
  },
  '& .react-resizable-handle-w': {
    cursor: 'ew-resize',
    height: 'calc(100% - 24px)',
    left: 0,
    top: 12,
    width: 8,
  },
  '& .react-resizable-handle-ne': {
    cursor: 'ne-resize',
    height: 16,
    right: 0,
    top: 0,
    width: 16,
  },
  '& .react-resizable-handle-nw': {
    cursor: 'nw-resize',
    height: 16,
    left: 0,
    top: 0,
    width: 16,
  },
  '& .react-resizable-handle-se': {
    bottom: 0,
    cursor: 'se-resize',
    height: 16,
    right: 0,
    width: 16,
    '&::after': {
      borderBottom: `2px solid ${FORTA_BLUE.primary}`,
      borderRight: `2px solid ${FORTA_BLUE.primary}`,
      bottom: 4,
      content: '""',
      height: 8,
      position: 'absolute',
      right: 4,
      width: 8,
    },
  },
  '& .react-resizable-handle-sw': {
    bottom: 0,
    cursor: 'sw-resize',
    height: 16,
    left: 0,
    width: 16,
  },
};

export const DOCUMENT_PREVIEW_BODY_SX = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
} as const;

export const DOCUMENT_PREVIEW_HEADER_SX = {
  alignItems: 'center',
  backgroundColor: FORTA_BLUE.lightest,
  boxShadow: '4px 4px 4px rgba(74, 74, 74, 0.1)',
  color: FORTA_BLUE.primary,
  cursor: 'move',
  display: 'flex',
  flexShrink: 0,
  justifyContent: 'space-between',
  pb: 1,
  pt: 2,
  px: 2,
  userSelect: 'none',
} as const;

export const DOCUMENT_PREVIEW_CONTENT_SX = {
  alignItems: 'center',
  display: 'flex',
  flex: 1,
  justifyContent: 'center',
  minHeight: 0,
  overflow: 'auto',
  pb: 2,
  px: 2,
} as const;

export const DOCUMENT_PREVIEW_IMAGE_SX = {
  display: 'block',
  height: '100%',
  maxHeight: '100%',
  maxWidth: '100%',
  objectFit: 'contain',
  width: '100%',
} as const;
